import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	PutRefundUpdateRequest,
	PutRefundUpdateRequestParams,
	PutRefundUpdateRequestResponse,
} from 'domain/usecases/private/refund/request/put-update-request';

export class RemoteRefundPutUpdateRequest implements PutRefundUpdateRequest {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PutRefundUpdateRequestResponse>,
	) {}

	async post(params: PutRefundUpdateRequestParams): Promise<PutRefundUpdateRequestResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'put',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
